/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Vuex from 'vuex'
import './ActionTypes'
// Store functionality
import i18n from "@/plugins/i18n";
import ActionTypes from "@/store/ActionTypes";
import StaffService from "@/services/staff.service";
import UserService from "@/services/user.service";
import AppService from "@/services/app.service";
import $const from "@/utils/const";
import router from "@/router";
import BotService from "@/services/bot.service";
import _ from 'lodash';
import customerService from '@/services/customer.service';
import * as modules from './modules'
Vue.use(Vuex);

const SMALL_SIZE = 1440;
// Create a new store
const store = new Vuex.Store({
    modules,
    state: {
        scClient: null,
        channelsClientChat: null,
        channelsAdminChat: null,
        channelsNotiAdmin: null,
        channelsNotiBot: null,
        notifyStaffChat: {},
        notificationCount: 0,
        isSmallScreen: window.innerWidth <= SMALL_SIZE,
        botStaffList: [],
        staffList: [],
        chatView: {
            botCode: null,
            senderId: null,
            channelId: null,
            customer: null,
            livesupport_log: null
        },
        botStatus: false,
        supporter: null,
        notifyBotChat: null,
        activeStaff: {},
        botList: [],
        botListPin: [],
        channelSelected: 'all',
        tab: {name: 'all', empty_message: 'allCustomersEmptyMessage'},
        user: localStorage.getItem('fptai_messenger_user_jwt') ? JSON.parse(localStorage.getItem('fptai_messenger_user_jwt')).user : {},
        token: localStorage.getItem('fptai_messenger_user_jwt') ? JSON.parse(localStorage.getItem('fptai_messenger_user_jwt')).user_token : '',
        bot: {},
        lastSessionID: '',
        lightBoxData: [],
        lightBoxIndex: null,
        updateAutoAssignConfig: null,
        enableAutoAssign: false,
        requestSupportCategories: [],
        autoAssignConfigMap: {},
        unreadUserNotifies: {
            data: [],
            total: 0,
        },
        agentConfig: {},
        messageCache: {},
    },
    mutations: {
        [ActionTypes.USER]: (state, payload) => {
            state.user = payload
        },
        [ActionTypes.TOKEN]: (state, payload) => {
            state.token = payload
        },
        [ActionTypes.SMALL_SCREEN]: (state, payload) => {
            state.isSmallScreen = payload
        },
        [ActionTypes.NOTIFY_CUSTOMER_CHANNELS]: (state, payload) => {
            const data = payload && payload.data ? payload.data : {};
            const {bot_code, sender_id} = data;
            const isEnableNotify = store.getters['config/isEnableNotify']
            switch (payload.type) {
                case $const.SOCKETCLUSTER_NOTI_DATA_TYPE.DEACTIVATE_BOT:
                    if (
                        payload.data.bot_code === state.chatView.botCode &&
                        payload.data.sender_id === state.chatView.senderId
                    ) {
                        state.botStatus = payload.data.bot_status;
                        if (payload.data.bot_status) {
                            state.supporter = $const.BOT_SUPPORTER
                        }
                    }
                    break;
                case $const.SOCKETCLUSTER_NOTI_DATA_TYPE.ADMIN_ASSIGN_SUPPORT:
                    if (
                        state.chatView.botCode === bot_code &&
                        state.chatView.senderId === sender_id
                    ) {
                        state.supporter = payload.data.supporter;
                        state.botStatus = false;
                        if (payload.data.livesupport_log) {
                            state.chatView.livesupport_log = payload.data.livesupport_log;
                        }
                    }
                    if (data.set_other_as_read === true) {
                        let remove_total = 0;
                        let notiList = state.unreadUserNotifies.data.filter(function(notification) {
                            if (bot_code !== notification.extra_data.bot_code || sender_id !== notification.extra_data.sender_id) {
                                return true;
                            }
                            if (data.noti_user_id === state.user.id &&
                                notification.type === $const.SOCKETCLUSTER_NOTI_DATA_TYPE.ADMIN_ASSIGN_SUPPORT) {
                                remove_total += (notification.count - 1);
                                notification.count = 1;
                                return true;
                            }
                            remove_total += notification.count;
                            return false;
                        });
                        let total = state.unreadUserNotifies.total - remove_total;
                        if (total < 0) {
                            total = 0
                        }
                        state.unreadUserNotifies = {
                            data: notiList,
                            total
                        };
                    }
                    store.dispatch('customer/processAssignAction', payload, {root: true})
                    break;
                case $const.SOCKETCLUSTER_NOTI_DATA_TYPE.USER_REQUEST_SUPPORT:
                    if (
                        payload.data.bot_code === state.chatView.botCode &&
                        payload.data.sender_id === state.chatView.senderId
                    ) {
                        BotService.getBotStatus(sender_id, bot_code).then(response => {
                            state.botStatus = response.data.status;
                            state.supporter = response.data.status ? $const.BOT_SUPPORTER : response.data.supporter
                        });
                        state.chatView.livesupport_log = null;
                    }
                    if (isEnableNotify) {
                        AppService.toast(
                            AppService.createToastLink(i18n.t('notifyRequestSupport'), bot_code, sender_id),
                            'info',
                            2000
                        );
                        AppService.osNotify(
                            `${i18n.t('notifyRequestSupport')}`,
                            bot_code,
                            sender_id
                        );
                    }
                    store.dispatch('customer/processRequestSupport', payload, {root: true})
                    break;
                case $const.SOCKETCLUSTER_NOTI_DATA_TYPE.MESSAGE_SEEN:
                    // TODO - handler seen message
                    break;
                case $const.SOCKETCLUSTER_NOTI_DATA_TYPE.UPDATE_AUTO_ASSIGN_CONFIG:
                    if (!payload || !payload.data || payload.data.bot_code !== state.bot.code || !payload.data.user_id) {
                        break;
                    }
                    state.updateAutoAssignConfig = payload.data;
                    state.autoAssignConfigMap[payload.data.user_id] = {
                        active: (payload.data.active === true),
                        request_support_categories: (payload.data.request_support_categories || [])
                    }
                    break;
                case $const.SOCKETCLUSTER_NOTI_DATA_TYPE.MARK_AS_DONE:
                    if (data.set_other_as_read === true) {
                        let remove_total = 0;
                        let notiList = state.unreadUserNotifies.data.filter(function(notification) {
                            if (bot_code !== notification.extra_data.bot_code || sender_id !== notification.extra_data.sender_id) {
                                return true;
                            }
                            remove_total += notification.count;
                            return false;
                        });
                        let total = state.unreadUserNotifies.total - remove_total;
                        if (total < 0) {
                            total = 0
                        }
                        state.unreadUserNotifies = {
                            data: notiList,
                            total
                        };
                    }
                    store.dispatch('customer/processMAD', payload, {root: true})
                    break;
                default:
            }
            state.notifyBotChat = payload
        },
        [ActionTypes.NOTIFY_ADMIN_CHANNELS]: (state, payload) => {
            let payload_data = payload && payload.data ? payload.data : {};
            let bot_code = payload_data.bot_code, sender_id = payload_data.sender_id, notify = payload_data.notify;
            let {formatted_msg, message} = UserService.format_notify_message(notify)
            const isEnableNotify = store.getters['config/isEnableNotify']
            notify.formatted_msg = formatted_msg;
            notify.content = message;
            if (!!notify && notify.read_status === false) {
                notify.count = 1;
                let notifyList = [notify]
                let extra_data = notify.extra_data || {};
                for (let _noti of state.unreadUserNotifies.data) {
                    let _ext_data = _noti.extra_data || {};
                    if (_noti.user_id === notify.user_id
                        && _ext_data.bot_code === extra_data.bot_code
                        && _ext_data.sender_id === extra_data.sender_id) {
                        if (_noti.count > 0) {
                            notify.count = _noti.count + 1;
                        } else {
                            notify.count++;
                        }
                        continue;
                    }
                    notifyList.push(_noti);
                }

                let total = state.unreadUserNotifies.total + 1;
                state.unreadUserNotifies= {
                    data: notifyList,
                    total: total
                };
            }
            switch (payload.type) {
                case $const.SOCKETCLUSTER_NOTI_DATA_TYPE.ADMIN_ASSIGN_SUPPORT:
                    if (
                        state.chatView.botCode === bot_code &&
                        state.chatView.senderId === sender_id
                    ) {
                        state.supporter = payload.data.supporter;
                        state.botStatus = false;
                        if (payload.data.livesupport_log) {
                            state.chatView.livesupport_log = payload.data.livesupport_log;
                        }
                    }
                    if (StaffService.getMe().id === payload.data.supporter.id) {
                        let message, formatted_msg;
                        if (state.chatView.botCode !== bot_code && !!notify && !!notify.content) {
                            message = notify.content;
                            formatted_msg = notify.formatted_msg ? notify.formatted_msg : notify.content;
                        } else {
                            formatted_msg = message = i18n.t('notifyAssignedSupport');
                        }
                        if (isEnableNotify) {
                            AppService.toast(
                                AppService.createToastLink(formatted_msg, bot_code, sender_id),
                                'info',
                                2000
                            );
                            AppService.osNotify(
                                message,
                                bot_code,
                                sender_id
                            );
                        }
                    }
                    break;
                case $const.SOCKETCLUSTER_NOTI_DATA_TYPE.ADMIN_SEND_MSG:
                    if (
                        payload.to_uid === StaffService.getMe().id &&
                        payload.from_uid !== state.activeStaff.id
                    ) {
                        if (state.notifyStaffChat.hasOwnProperty(payload.from_uid)) {
                            state.notifyStaffChat[payload.from_uid]++
                        } else {
                            Vue.set(state.notifyStaffChat, payload.from_uid, 1);
                        }
                        state.notificationCount = _.keys(state.notifyStaffChat).length
                    }
                    break;
                case $const.SOCKETCLUSTER_NOTI_DATA_TYPE.USER_REQUEST_SUPPORT:
                    if (state.chatView.botCode !== bot_code) {
                        let message, formatted_msg;
                        if (!!notify && !!notify.content) {
                            message = notify.content;
                            formatted_msg = notify.formatted_msg ? notify.formatted_msg : notify.content;
                        } else {
                            formatted_msg = message = i18n.t('notifyRequestSupport');
                        }
                        if (isEnableNotify) {
                            AppService.toast(
                                AppService.createToastLink(formatted_msg, bot_code, sender_id),
                                'info',
                                2000
                            );
                            AppService.osNotify(
                                message,
                                bot_code,
                                sender_id
                            );
                        }
                    }
                    break;
                default:
                    break;
            }
        },
        [ActionTypes.BOT_STAFF]: (state, payload) => {
            state.botStaffList = payload;
            let staffList = [];
            for (let bot of payload) {
                staffList = staffList.concat(bot.staffs)
            }
            state.staffList = _.uniqBy(staffList, item => item.id);
        },
        [ActionTypes.CHANGE_CHAT_VIEW]: (state, payload) => {

        },
        [ActionTypes.BOT_STATUS]: (state, payload) => {
            state.botStatus = payload
        },
        [ActionTypes.BOT]: (state, payload) => {
            state.bot = payload
        },
        [ActionTypes.SUPPORTER]: (state, payload) => {
            state.supporter = payload
        },
        [ActionTypes.ACTIVE_STAFF]: (state, payload) => {
            state.activeStaff = payload;
            if (payload) {
                state.notifyStaffChat = _.omit(state.notifyStaffChat, [payload.id]);
                state.notificationCount = _.keys(state.notifyStaffChat).length
            }
        },
        [ActionTypes.BOT_LIST]: (state, payload) => {
            state.botList = payload
        },
        [ActionTypes.BOT_LIST_PIN]: (state, payload) => {
            state.botListPin = payload
        },
        [ActionTypes.CHANNEL]: (state, payload) => {
            state.channelSelected = payload
        },
        [ActionTypes.CHAT_TAB]: (state, payload) => {
            state.tab = payload
        },
        [ActionTypes.LAST_SESSION_ID]: (state, payload) => {
            state.lastSessionID = payload;
        },
        [ActionTypes.SET_LIGHT_BOX_DATA_THEN_SHOW]: (state, payload) => {
            if (payload.data && payload.data.length > 0) {
                state.lightBoxData  = [...payload.data]
                state.lightBoxIndex = payload.index || payload.index === 0 ? payload.index : null
            } else {
                state.lightBoxData  = []
                state.lightBoxIndex = null
            }
        },
        [ActionTypes.GET_ALL_AUTO_ASSIGN_CONFIG]: (state, payload)=> {
            if (payload) {
                state.enableAutoAssign = payload.enable_auto_assign === "1";
                state.requestSupportCategories = payload.rs_categories || [];
                let supporters = payload.supporters || [];
                let autoAssignConfigMap = {}
                for (let supporter of supporters) {
                    if (supporter.auto_assign_config) {
                        autoAssignConfigMap[supporter.id] = {
                            active: (supporter.auto_assign_config.active === true),
                            request_support_categories: (supporter.auto_assign_config.request_support_categories || []),
                        }
                    }
                }
                state.autoAssignConfigMap = autoAssignConfigMap;
            }
        },
        [ActionTypes.GET_UNREAD_USER_NOTIFY]: (state, payload)=> {
            if (payload) {
                let data = [];
                for (let notify of payload.results) {
                    if (!!notify && !!notify.content && !!notify.extra_data) {
                        let {formatted_msg, message} = UserService.format_notify_message(notify)
                        notify.formatted_msg = formatted_msg;
                        notify.content = message;
                    }
                    data.push(notify);
                }

                state.unreadUserNotifies = {
                    data,
                    total: payload.count
                };
            }
        },
        [ActionTypes.AGENT_CONFIG]: (state, payload) => {
            for (let key of Object.keys(payload)) {
                Vue.set(state.agentConfig, key, payload[key])
            }
        },
        [ActionTypes.MESSAGE_CACHE]: (state, payload) => {
            Vue.set(state.messageCache, payload.sender_id, Object.assign(state.messageCache[payload.sender_id] || {}, payload))
        },
        [ActionTypes.DEL_MESSAGE_CACHE]: (state, payload) => {
            Vue.delete(state.messageCache, payload)
        },
    },
    actions: {
        [ActionTypes.GET_BOT_STAFF]: (context) => {
            StaffService.getAvailableStaff().then(
                result => {
                    context.commit(ActionTypes.BOT_STAFF, result.data)
                },
            )
        },
        [ActionTypes.CHANGE_CHAT_VIEW]: ({state, commit}, payload) => {
            if (payload.senderId) {
                BotService.getCustomerInfo(payload.botCode, payload.senderId).then(
                    result => {
                        let me = StaffService.getMe() ? StaffService.getMe() : {};
                        let supporter = result.data.supporter;
                        if(!supporter || supporter && supporter.id === me.id) {
                            customerService.sendStatusSeenCustomerMessage(payload.botCode, payload.senderId);
                        }
                        state.supporter = result.data.supporter;
                        commit('customer/setCurrentCustomer', result.data)
                        let interval = setInterval(() => {
                            if (state.botStaffList.length && state.botStaffList.length > 0) {
                                clearInterval(interval);
                                state.chatView = {
                                    botCode: payload.botCode,
                                    senderId: payload.senderId,
                                    customer: result.data,
                                    supporter: result.data.supporter,
                                    channelId: StaffService.createRoom(
                                        payload.senderId,
                                        payload.botCode,
                                        $const.STAFF_CHANNEL
                                    ),
                                    livesupport_log: null
                                };
                            }
                        }, 500);
                    },
                    () => {
                        router.push('/')
                    }
                );
            } else {
                state.currentCustomer = {}
                state.chatView = {
                    botCode: null,
                    senderId: null,
                    channelId: null,
                    customer: null,
                    livesupport_log: null
                };
            }
            // context.commit(ActionTypes.CHANGE_CHAT_VIEW, payload)
        },
        [ActionTypes.CHANNEL]: (context, payload) => {
            context.commit(ActionTypes.CHANNEL, payload)
        },
        [ActionTypes.CHAT_TAB]: (context, payload) => {
            context.commit(ActionTypes.CHAT_TAB, payload)
        },
        [ActionTypes.LAST_SESSION_ID]: (context, payload) => {
            context.commit(ActionTypes.LAST_SESSION_ID, payload);
        },
        [ActionTypes.SET_LIGHT_BOX_DATA_THEN_SHOW]: (context, payload) => {
            context.commit(ActionTypes.SET_LIGHT_BOX_DATA_THEN_SHOW, payload);
        },
    },
    getters: {
        channel: state => state.chatView.customer.sender_channel,
        isAdminRole: state => {
            if (state.bot.code) {
                return StaffService.checkStaffHasRole(state.bot.code, state.user.id, [10, 9, 5]);
            }
            return false;
        }
    }
});

window.addEventListener('resize', () => {
    store.commit(ActionTypes.SMALL_SCREEN, window.innerWidth <= SMALL_SIZE);
});

window.goToChannel = (botCode, senderId) => {
    store.dispatch(ActionTypes.CHANNEL, 'all');
    store.dispatch(ActionTypes.CHAT_TAB, 'allChats');
    router.push(`/bot/${botCode}/s/${senderId}`)
}

export default store
